import React, { Component } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap-icons/font/bootstrap-icons.css";
import StockList from "./StockList";
import DonationLimitList from "./donationlimit";
class ShelfLifeSettings extends Component {
  constructor(props) {
    super(props);
    this.state = {
      shelfLifeDays: null,
      updatedAt: null,

      loading: true,
      saving: false,
      error: "",
      success: "",

      showModal: false,
      formDays: "",
    };
  }

  componentDidMount() {
    this.fetchSetting();
  }

  showAlert(type, msg) {
    this.setState({ [type]: msg });
    setTimeout(() => this.setState({ [type]: "" }), 4000);
  }

  fetchSetting = () => {
    this.setState({ loading: true });
    fetch(`${process.env.REACT_APP_API_BASE_URL}/api/shelf-life-setting`, { credentials: "include" })
      .then((res) => res.json())
      .then((data) => {
        this.setState({
          shelfLifeDays: data.shelf_life_days ?? null,
          updatedAt: data.updated_at || null,
          loading: false,
        });
      })
      .catch(() => {
        this.setState({ loading: false });
        this.showAlert("error", "Failed to load shelf life setting.");
      });
  };

  openModal = () => {
    this.setState({
      showModal: true,
      formDays: this.state.shelfLifeDays ?? "",
    });
  };

  closeModal = () => {
    if (this.state.saving) return;
    this.setState({ showModal: false });
  };

  handleSave = (e) => {
    e.preventDefault();
    const days = parseInt(this.state.formDays, 10);

    if (!days || days < 1 || days > 365) {
      return this.showAlert("error", "Enter a number of days between 1 and 365.");
    }

    this.setState({ saving: true });
    fetch(`${process.env.REACT_APP_API_BASE_URL}/api/shelf-life-setting`, {
      method: "POST",
      credentials: "include",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ shelf_life_days: days }),
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.shelf_life_days !== undefined) {
          this.setState({
            shelfLifeDays: data.shelf_life_days,
            updatedAt: new Date().toISOString(),
            saving: false,
            showModal: false,
          });
          this.showAlert("success", "Shelf life rule saved.");
        } else {
          this.setState({ saving: false });
          this.showAlert("error", data.message || "Failed to save.");
        }
      })
      .catch(() => {
        this.setState({ saving: false });
        this.showAlert("error", "Network error. Could not save.");
      });
  };

  render() {
    const {
      shelfLifeDays, updatedAt,
      loading, saving, error, success,
      showModal, formDays,
    } = this.state;

    const isSet = shelfLifeDays !== null && shelfLifeDays !== undefined;

    return (
      <div style={{ background: "#f4f6fb", minHeight: "100vh" }} className="pt-5 mt-4">
        <div className="container-fluid py-4 px-4 px-lg-5">

          {/* ── Page header ─────────────────────────────────── */}
          <div className="mb-4">
            <h4 className="fw-bold mb-1" style={{ color: "#c9140e" }}>
              <i className="bi bi-hourglass-split me-2" />
              Blood Shelf Life
            </h4>
            <p className="text-muted small mb-0">
              Set how many days a blood bag stays usable after donation.
            </p>
          </div>

          {/* ── Alerts ──────────────────────────────────────── */}
          {error && (
            <div className="alert alert-danger d-flex align-items-center py-2 small mb-3">
              <i className="bi bi-exclamation-triangle-fill me-2" /> {error}
            </div>
          )}
          {success && (
            <div className="alert alert-success d-flex align-items-center py-2 small mb-3">
              <i className="bi bi-check-circle-fill me-2" /> {success}
            </div>
          )}

          {/* ── Content ─────────────────────────────────────── */}
          {loading ? (
            <div className="card border-0 shadow-sm">
              <div className="card-body text-center py-5">
                <div className="spinner-border text-danger" />
                <p className="text-muted small mt-2 mb-0">Loading setting...</p>
              </div>
            </div>
          ) : !isSet ? (
            // ── Empty state: nothing set yet ──────────────────
            <div
              className="card border-0"
              style={{
                borderRadius: 14,
                border: "2px dashed #d9dee6",
                background: "#fff",
              }}
            >
              <div className="card-body text-center py-5">
                <div
                  style={{
                    width: 64, height: 64, borderRadius: "50%",
                    background: "#fdeceb", display: "flex",
                    alignItems: "center", justifyContent: "center",
                    margin: "0 auto 16px",
                  }}
                >
                  <i className="bi bi-hourglass-split" style={{ fontSize: 26, color: "#c9140e" }} />
                </div>
                <h6 className="fw-bold mb-1">No shelf life rule set</h6>
                <p className="text-muted small mb-4">
                  Add a rule so newly donated bags get an expiry date automatically.
                </p>
                <button
                  onClick={this.openModal}
                  style={{
                    background: "#c9140e", color: "#fff",
                    border: "none", borderRadius: 8,
                    padding: "10px 22px", fontWeight: 600, fontSize: 14,
                    cursor: "pointer", display: "inline-flex",
                    alignItems: "center", gap: 6,
                  }}
                >
                  <i className="bi bi-plus-lg" />
                  Add Shelf Life Rule
                </button>
              </div>
            </div>
          ) : (
            // ── Set state: show the active rule ───────────────
            <div className="card border-0 shadow-sm" style={{ borderRadius: 14, overflow: "hidden" }}>
              <div
                style={{
                  background: "linear-gradient(135deg, #c9140e 0%, #a10f0a 100%)",
                  padding: "24px 28px",
                }}
                className="d-flex justify-content-between align-items-center flex-wrap gap-3"
              >
                <div className="d-flex align-items-center gap-3">
                  <div
                    style={{
                      width: 52, height: 52, borderRadius: 12,
                      background: "rgba(255,255,255,0.15)",
                      display: "flex", alignItems: "center", justifyContent: "center",
                    }}
                  >
                    <i className="bi bi-hourglass-split" style={{ fontSize: 22, color: "#fff" }} />
                  </div>
                  <div>
                    <div style={{ color: "rgba(255,255,255,0.75)", fontSize: 12, fontWeight: 600, letterSpacing: 0.4 }}>
                      CURRENT SHELF LIFE
                    </div>
                    <div style={{ color: "#fff", fontSize: 30, fontWeight: 800, lineHeight: 1.1 }}>
                      {shelfLifeDays} <span style={{ fontSize: 16, fontWeight: 500 }}>days</span>
                    </div>
                  </div>
                </div>
                <button
                  onClick={this.openModal}
                  style={{
                    background: "#fff", color: "#c9140e",
                    border: "none", borderRadius: 8,
                    padding: "9px 18px", fontWeight: 600, fontSize: 14,
                    cursor: "pointer", display: "flex", alignItems: "center", gap: 6,
                  }}
                >
                  <i className="bi bi-pencil-square" />
                  Edit
                </button>
              </div>

              <div className="card-body">
                <div className="d-flex justify-content-between align-items-center py-2 border-bottom">
                  <span className="text-muted small">Applies to</span>
                  <span className="fw-semibold small">Newly donated bags</span>
                </div>
                <div className="d-flex justify-content-between align-items-center py-2">
                  <span className="text-muted small">Last updated</span>
                  <span className="fw-semibold small">
                    {updatedAt
                      ? new Date(updatedAt).toLocaleString("en-PK", {
                          dateStyle: "medium", timeStyle: "short",
                        })
                      : "—"}
                  </span>
                </div>

                <div
                  className="d-flex align-items-start gap-2 mt-3 p-2"
                  style={{ background: "#f7f8fa", borderRadius: 8 }}
                >
                  <i className="bi bi-info-circle text-muted mt-1" style={{ fontSize: 13 }} />
                  <p className="text-muted small mb-0">
                    Changing this only affects bags donated after the change. Existing bags keep the rule that was active on their donation date.
                  </p>
                </div>
              </div>
            </div>
          )}

          <div className="mt-5">
            <StockList showHeader={true} />
          </div>
          <div className= "mt-4">
            <DonationLimitList showHeader={true} />
          </div>
        </div>

        {/* ── Add / Edit Modal ──────────────────────────────── */}
        {showModal && (
          <div
            style={{
              position: "fixed", inset: 0, zIndex: 2000,
              background: "rgba(0,0,0,0.45)",
              display: "flex", alignItems: "center", justifyContent: "center",
              padding: 16,
            }}
            onClick={this.closeModal}
          >
            <div
              style={{
                background: "#fff", borderRadius: 12,
                width: "100%", maxWidth: 420,
                boxShadow: "0 8px 32px rgba(0,0,0,0.18)",
                overflow: "hidden",
              }}
              onClick={(e) => e.stopPropagation()}
            >
              {/* Modal header */}
              <div style={{
                padding: "16px 20px", borderBottom: "1px solid #f0f0f0",
                display: "flex", justifyContent: "space-between", alignItems: "center",
              }}>
                <h6 style={{ margin: 0, fontWeight: 700 }}>
                  <i className="bi bi-hourglass-split me-2 text-danger" />
                  {isSet ? "Edit Shelf Life Rule" : "Add Shelf Life Rule"}
                </h6>
                <button
                  onClick={this.closeModal}
                  disabled={saving}
                  style={{
                    background: "none", border: "none", fontSize: 20,
                    cursor: "pointer", color: "#888", lineHeight: 1,
                  }}
                >×</button>
              </div>

              {/* Modal body */}
              <form onSubmit={this.handleSave}>
                <div style={{ padding: 20 }} className="d-flex flex-column gap-3">
                  <div>
                    <label className="form-label fw-semibold small mb-1">
                      Shelf life (days) *
                    </label>
                    <input
                      type="number"
                      className="form-control"
                      min="1"
                      max="365"
                      placeholder="e.g. 35"
                      value={formDays}
                      onChange={(e) => this.setState({ formDays: e.target.value })}
                      autoFocus
                    />
                    <div className="form-text">
                      Applies only to bags donated from now on. Existing bags are unaffected.
                    </div>
                  </div>
                </div>

                {/* Modal footer */}
                <div style={{
                  padding: "12px 20px", borderTop: "1px solid #f0f0f0",
                  display: "flex", justifyContent: "flex-end", gap: 10,
                }}>
                  <button
                    type="button"
                    onClick={this.closeModal}
                    disabled={saving}
                    style={{
                      padding: "8px 18px", borderRadius: 8,
                      border: "1px solid #ddd", background: "#f8f9fa",
                      fontWeight: 600, cursor: "pointer",
                    }}
                  >
                    Cancel
                  </button>
                  <button
                    type="submit"
                    disabled={saving}
                    style={{
                      padding: "8px 20px", borderRadius: 8,
                      border: "none", background: "#c9140e",
                      color: "#fff", fontWeight: 600, cursor: "pointer",
                      minWidth: 90,
                    }}
                  >
                    {saving
                      ? <span className="spinner-border spinner-border-sm" />
                      : <><i className="bi bi-save me-1" />Save</>
                    }
                  </button>
                </div>
              </form>
            </div>
          </div>
        )}
      </div>
    );
  }
}

export default ShelfLifeSettings;